module.exports = __webpack_public_path__ + "static/media/03-quote-03-samsung@2x.25f5ef0c.jpg";